import styled from 'styled-components'
import { DASHCOLORS } from 'bd-web-components'

export const TextTableCategory = styled.div`
  margin-top: 0px;
  color: ${DASHCOLORS.PRIMARY_BLUE_02};
  font-weight: 500;
  font-size: 15px;
`

export const monthlyColumns = (origem: string) => {
  const width = 50

  const renderText = ({ value }: any) => (
    <TextTableCategory>{value}</TextTableCategory>
  )

  return [
    {
      title: 'Mês',
      key: 'monthName' + origem,
      dataIndex: 'monthName',
      right: false,
      removeBorderRight: true,
      render: renderText,
      borderBottom: true,
      width: width - 20,
    },
    {
      title: 'Variação',
      key: 'revenueVariation' + origem,
      dataIndex: 'revenueVariation',
      render: renderText,
      right: true,
      removeBorderRight: true,
      borderBottom: true,
      width: width - 5,
    },
    {
      title: 'Receita',
      key: 'totalRevenue' + origem,
      dataIndex: 'totalRevenue',
      render: renderText,
      right: true,
      removeBorderRight: true,
      borderBottom: true,
      width: width,
    },

    {
      title: 'Potencial Total',
      key: 'totalSalesWithFees' + origem,
      dataIndex: 'totalSalesWithFees',
      render: renderText,
      right: true,
      removeBorderRight: true,
      borderBottom: true,
      width: width,
    },
    {
      title: 'P. Executado',
      key: 'totalRequested' + origem,
      dataIndex: 'totalRequested',
      render: renderText,
      right: true,
      removeBorderRight: true,
      borderBottom: true,
      width: width,
    },
    {
      title: 'Conversão',
      key: 'totalConversion' + origem,
      dataIndex: 'totalConversion',
      render: renderText,
      right: true,
      removeBorderRight: true,
      borderBottom: true,
      width: width - 30,
    },
    {
      title: 'Taxa média',
      key: 'averageRate' + origem,
      dataIndex: 'averageRate',
      render: renderText,
      right: true,
      removeBorderRight: true,
      borderBottom: true,
      width: width - 30,
    },
  ]
}
